import { CategoryMapper } from 'mapper/CategoryMapper';

export const categoryMapper = new CategoryMapper();
